import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { ApplicationError, NotificationService } from '@ntap/core';
import { injectQueryClient } from '@tanstack/angular-query-experimental';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AuthService } from './service/auth.service';

@Component({
  templateUrl: './login.component.html'
})
export class LoginComponent {
  loginForm!: FormGroup;
  submitted = false;

  private queryClient = injectQueryClient();

  constructor(
    private layoutService: LayoutService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private router: Router
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  get dark(): boolean {
    return this.layoutService.config.colorScheme !== 'light';
  }

  onLoginSubmit(
    event: Event,
    value: { username: string; password: string }
  ): void {
    this.submitted = true;
    this.disableFormInputs();
    event.preventDefault();
    this.authService.login(value).subscribe(
      () => {
        this.queryClient.clear();
        this.submitted = false;
        this.router.navigate(['']);
      },
      (error) => {
        this.submitted = false;
        this.enableFormInputs();
        this.showError(error);
      }
    );
  }

  forgottenPassword(event: Event): void {
    event.preventDefault();
    this.router.navigate(['login', 'forgot-password']);
  }

  loginFormControl(controlName: string): FormControl {
    return this.loginForm.controls[controlName] as FormControl;
  }

  private showError(error: HttpErrorResponse): void {
    const exception = new ApplicationError(error);
    this.notificationService.error(`${exception.message}`);
  }

  private disableFormInputs(): void {
    this.loginForm.disable();
  }

  private enableFormInputs(): void {
    this.loginForm.enable();
  }
}
